var app_html = null;
(function ($) {
    
    /**
     * Generates the html for the app!
     * @param {Object} _settings
     * @returns {app_html}
     */
    app_html = function(_settings) { 
        
        var self = this;
        self.settings = _settings; 

        self.characters = [
            'Klassisk komposition',
            'Kreativt koncept',
            'Familjär funktion',
            'Stilfull samvaro',
        ];

        self.gethtml = function () { 
            var html = "";
            html += '<div id="b-container">';
            html += '<div id="b-innercontainer">';
            html += '<div id="b-appcontent" style="display:none;">';
            html += '<div id="b-theapp">';
            if(self.settings.views > 1){ 
            html += '<div class="changeView">';
        }else{
            html += '<div class="changeView">';
        }
            for (var i = 1; i < (self.settings.views + 1); i++) {
                if(self.settings.view_names && typeof self.settings.view_names[i] !== "undefind"){
                    html += '<a href="javascript:;" id="changeView' + i + '" data-id="' + (i - 1) + '">' + self.settings.view_names[i] +'</a>';
                }else{
                    html += '<a href="javascript:;" id="changeView' + i + '" data-id="' + (i - 1) + '">Vinkel ' + i + '</a>';    
                }
                
            }

            /**
             * Solstudie
             * 
             */
            if (self.settings.theme === 'parkterassen') {
                html += '<a class="external" href="https://bostadsvaljaren.se/solstudie/parkterassen.php">Solstudie</a>';
            }

            /**
             * Link to sun study
             */
            if (self.settings.theme === 'veidekke') {
                html += '<a class="external logo" target="_blank" href="https://www.nordr.se/nyproduktion/goteborg/innerstaden/ciceron/"><img src="/icons/logo.svg" title="Nordr"/></a>';
            }


            html += '</div>';
            
            
                html += '<div class="views">';    
 
            
            html += '<svg id="svg" viewBox="0 0 ' + self.settings.width + ' ' + self.settings.height + '" preserveAspectRatio="xMidYMid"></svg>';
            html += '<div id="hoverpop"></div>';

            if(self.settings.animation){

                html += '<div class="anmation" id="animation">';

                html += '</div>';

                html += '<div class="animation-play" id="animation-play-left"></div>';
                html += '<div class="animation-play" id="animation-play-right"></div>';

            }


            for (var k = 1; k < (self.settings.views + 1); k++) { 
                html += '<div class="view" id="view' + k + '" style="display:none;">';

                html += '</div>';
            }

            //VIews
            html += '</div>';
            html += '<div id="controls-wrapper">';

            if (self.settings.theme === 'link_theme') {
                html += '<div id="info_title">';
                html += '<h3>Bostäder och Priser:</h4>';
                html += '</div>';
            }

            html += '<div id="controls">';
            html += '<div id="colors">';
            html += '<div class="ledig"><span></span>Ledig</div>';
            html += '<div class="reserverad"><span></span>Reserverad</div>';
            html += '<div class="sald"><span></span>Såld</div>';
            if (self.settings.info) {
                html += '<div class="info"><span></span>Information</div>';
            }
            html += '</div>';

            


            html += '<div id="sliders">';

            html += '<div id="sliderRoom" class="slider">';
 
            console.log(self.settings.theme);

            if (self.settings.theme === 'viste') {
                html += '<p><label for="room">Max antal bäddar</label><input type="text" disabled="disabled" id="roomet"></p>';
            }else{
                html += '<p><label for="room">Rum</label><input type="text" disabled="disabled" id="roomet"></p>';
            }
            html += '<div id="sliderRum"></div>';
            html += '</div>';

            

            html += '<div id="sliderPris" class="slider">';
            html += '<p><label for="price">Pris</label><input type="text" disabled="disabled" id="price"></p>';
            html += '<div id="sliderPrice"></div>';
            html += '</div>';

            html += '<div id="sliderBoArea" class="slider">'; 
            html += '<p><label for="boarea">Boarea</label><input type="text" disabled="disabled" id="boarea"></p>';
            html += '<div id="sliderBo"></div>';

            html += '</div>';


            //Sliders
            html += '</div>';

            //Only AromaLund
            if(self.settings.theme === 'aromalund'){
                html += '<div id="characterSelect">';
                html += '<h3>Karaktär:</h3>';
                $.each(self.characters, function(index, key){
                    html += '<div class="character"><input type="checkbox" name="character[]" value="' + key + '" checked="checked"/><label>' + key + '</label></div>';
                });
                html += '</div>';
            }
 
            //html += '<div class="clearall"></div>';
            html += '<div class="showall">';
            html += '<input type="checkbox" id="showAll" name="showAll"><label for="showAll">Visa alla lediga</label>';
            html += '</div>';
            html += '<div class="toggleall">';
            html += '<input type="checkbox" id="toggleAll" name="toggleAll"><label for="toggleAll">Visa alla</label>';
            html += '</div>';

            //Controls
            html += '</div>';
            html += '</div>';
            //BTheApp
            html += '</div>';
            //BAppContent
            html += '</div>';
            //BInnerContainer
            html += '</div>';
            //BContainer
            html += '</div>';
            
            return html;
            
        };
 
        return self;

    }; 

})(jQuery);